import React from "react";
import "./style.scss";

interface IProps {
  value: string;
  label: string;
  name: string;
  setValue: (value: string) => void;
}

const InputText: React.FC<IProps> = ({ value, label, name, setValue }: IProps) => {
  return (
    <div className={"form-input-text"}>
      <label htmlFor={name}>{label}</label>
      <input type="text" value={value} name={name} onChange={event => setValue(event.target.value)} />
    </div>
  );
};

export default InputText;
